export { default } from './QuizBackground';
